exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.action-button[data-v-24341b87] {\n  margin-bottom: 8px;\n}\n.gap[data-v-24341b87] {\n  padding-left: 8px;\n}\n", ""]);

// exports
